export const data = [
  {
    sector: 'All Retail Clothing',
    growth: -4
  },
  {
    sector: 'Traditional Thrift & Donation',
    growth: 34
  },
  {
    sector: 'Resale',
    growth: 414
  }
];
